import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { ArrowLeftIcon } from "../../components/Icons";
import LoginWallet from "../../components/LoginWallet";
import logo from "../../imgs/logo_75.png";
import Router from "../../routes";
import menus from "../../utils/menus";

export default function MainLayout() {
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState(menus[0]);
  const [showSlide, setShowSlide] = useState<boolean>(true);
  const handleMenuClick = (menu: any) => {
    setSelectedMenu(menu);
    navigate(menu.path);
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowSize]);

  useEffect(() => {
    if (windowSize.innerWidth < 1028) setShowSlide(false);
    else setShowSlide(true);
  }, [windowSize]);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  return (
    <div className="flex w-full min-h-screen">
      <div
        className={`${
          showSlide ? "w-[300px]" : "w-[80px]"
        } flex shrink-0 transition-all duration-300 relative items-center`}
      >
        {/* <div className="w-1/5 flex justify-center border-r border-white border-opacity-20  items-start pt-6 bg-primary-100 bg-opacity-60">
          <img src={logo} width={40} alt="" />
        </div> */}
        <div className="w-full h-full bg-primary-100 bg-opacity-50 border-r border-white border-opacity-20 ">
          <div className="flex items-end py-3 px-4 text-white text-2xl font-bold tracking-widest">
            {" "}
            <img src={logo} width={40} alt="" /> {showSlide ? "OIL" : ""}
            {/* {selectedMenu?.name} */}
          </div>
          <div className="p-3">
            {menus.map((item, index) => {
              return (
                <div
                  key={index}
                  onClick={() => handleMenuClick(item)}
                  className={`text-white flex justify-start items-start relative text-lg  py-3 px-2 hover:bg-black hover:bg-opacity-50 cursor-pointer rounded ${
                    selectedMenu.name === item.name && item.completed
                      ? " text-sky-500"
                      : ""
                  }`}
                >
                  <div className="flex gap-2 items-center justify-center">
                    <div
                      className={`p-2 bg-primary-100 rounded-full ${
                        selectedMenu.name === item.name && item.completed
                          ? " bg-sky-500"
                          : ""
                      }`}
                    >
                      {item.icon}
                    </div>
                    {showSlide && item.name}
                  </div>
                  {!item.completed && showSlide && (
                    <span className="shadow-sm absolute right-0 shadow-black py-2 px-3 text-[8px] rounded-full inline-block whitespace-nowrap text-center align-baseline uppercase leading-none text-white">
                      Soon
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div
          className="absolute flex justify-center items-center h-[32px] w-[10px] rounded-tl-md rounded-bl-md bg-white right-0 cursor-pointer bg-opacity-20 hover:bg-opacity-40"
          onClick={() => setShowSlide(!showSlide)}
        >
          <ArrowLeftIcon
            className={`stroke-white w-4 h-4 ${showSlide ? "rotate-180" : ""}`}
          />
        </div>
      </div>
      <div className="w-full bg-primary-100 relative content-container ">
        <div className="absolute flex w-full justify-end items-end top-0 right-0 border-b  border-white border-opacity-20 bg-primary-100">
          <LoginWallet local={1} />
        </div>
        <Router />
      </div>
    </div>
  );
}
